import { render, staticRenderFns } from "./ProItem.vue?vue&type=template&id=d0b1b9d4"
import script from "./ProItem.vue?vue&type=script&lang=ts"
export * from "./ProItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports